// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 15,
        loadProductFirst: true
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'saleLabelHtml': '<div class="sale-badge">' + bcSfFilterConfig.label.sale + '</div>',
    'productGridItemHtml': '<div class="grid__item grid__item--variable-height {{itemHoverClass}}  grid__image grid__image--caption large--one-fifth medium--one-fifth">' +
  		//grid__item grid__item--variable-height grid__image {{itemHoverClass}} large--one-third medium--one-third">' +
                                '<a href="{{itemUrl}}" tabindex=\'0\'>' +
                                    '<div class="cell-wrapper" {{itemFlipImage}}>' +
                                        '{{itemSaleLabel}}' +
                                        '{{itemThumb}}' +
                                    '</div>' +
                                    '<span class="product_image_caption">' +
                                        '<h6>{{itemTitle}}</h6>' +
                                        '{{itemPrice}}' +
                                    '</span>' +
                                '</a>' +
                            '</div>' +
                           '{{itemNewRow}}',

    'previousHtml': '<span class="prev"><a href="{{itemUrl}}">&larr;</a></span>',
    'nextHtml': '<span class="next"><a href="{{itemUrl}}">&rarr;</a></span>',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span class="deco">{{itemTitle}}</span>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
    'sortingHtml': '<select>{{sortingItems}}</select>',
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    // Prepare data
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100;
    var soldOut = !data.available;
    var onSale = data.compare_at_price_min > data.price_min;
    var priceVaries = data.price_min != data.price_max;

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  
    // Add custom class
    var itemHoverClass = 'product_image focus_image';
    if (bcSfFilterConfig.custom.collection_style != '') {
        itemHoverClass = bcSfFilterConfig.custom.collection_style;
    }
    itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, itemHoverClass);
  
    // Add onSale label
    var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add Thumbnail
    var images = Object.keys(data.images).map(function (key) { return data.images[key]; });
    var itemThumbHtml = '<img src="//cdn.shopify.com/s/images/themes/product-1.png" class="placeholder-image">';
    if (images.length > 0) {
        var hoverClass = images.length > 1 ? 'has-hover' : ''
        itemThumbHtml = '<img src="' + this.optimizeImage(images[0], '700x') + '" alt="{{itemTitle}}" class="'+ hoverClass + '">';
    }
    itemHtml = itemHtml.replace(/{{itemThumb}}/g, itemThumbHtml);

    // Add Flip Image
    var itemFlipImage = '';
    if (images.length > 1) {
        var flipImageUrl = this.optimizeImage(images[1], '1024x');
        itemFlipImage = 'style="background-image: url(' + flipImageUrl + ')"';
    }
    itemHtml = itemHtml.replace(/{{itemFlipImage}}/g, itemFlipImage);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
        if (priceVaries) {
            itemPriceHtml += '<span class="price">' + bcSfFilterConfig.label.sale_from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min, this.moneyFormat)) + '</span>';
        } else {
            itemPriceHtml += '<span class="price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
        }
    } else {
        if (priceVaries) {
            itemPriceHtml += '<span class="price">' + bcSfFilterConfig.label.from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min, this.moneyFormat)) + '</span>';
        } else {
            itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
        }
    }
    if (soldOut) {
        itemPriceHtml += '<strong>' + bcSfFilterConfig.label.sold_out + '</strong>';
    }
    if (onSale) {
        itemPriceHtml += '<s><span class="price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span></s>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add new row
    var itemNewRow = index % 3 == 0 ? '<div class="bc-sf-filter-clearfix"></div>' : '';
    itemHtml = itemHtml.replace(/{{itemNewRow}}/g, itemNewRow);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data, false));

    return itemHtml;
};

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage in pageArr) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  this.buildRobotsMetaTag();
    $('.collection-sort').unbind('change');
};

BCSfFilter.prototype.prepareProductData = function(data) {
    // Cheat masonry
    $('#bc-sf-filter-products').addClass('bc-sf-filter-height');

    return data;
};
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
